import { inputCls } from "./ui";

export const SCOPES = [["real", "Operações reais"], ["demo", "DEMO"], ["test", "Testes"], ["all", "Tudo"]];

export function ScopeSelect({ value, onChange, testid = "scope-select" }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={`${inputCls} w-auto`} data-testid={testid}>
      {SCOPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
}

export function ScopeNote({ scope }) {
  if (scope === "real") return null;
  return <p className="rounded-xl border border-gray-300 bg-gray-100 px-3 py-2 text-xs font-semibold text-gray-700" data-testid="scope-note">
    A ver dados {scope === "all" ? "reais, DEMO e de teste" : scope === "demo" ? "DEMO" : "de teste"}: não representam apenas operações comerciais reais.</p>;
}
